import { ABaseMark } from '../base/Mark.js';
import { SentrySpan } from './Span.js';

/**
 * SentryMark
 */
export class SentryMark extends ABaseMark<SentrySpan> {
  /**
   * end
   *
   * @returns {void}
   */
  public end(): void {
    this.instance.end();
  }
}
